import {useTransformQuery} from 'web-app/react/hooks/use-transform-query';
import {hasValue} from '@famly/stat_ts-utils_has-value';

import {FetchIsAutomaticDecouplingEnabled} from '../queries';
import {
    type FetchIsAutomaticDecouplingEnabledQuery,
    type FetchIsAutomaticDecouplingEnabledQueryVariables,
} from '../__generated__/queries.api-types';

export const useIsAutomaticDecouplingEnabled = (siteSetId: string) => {
    const [isAutomaticDecouplingEnabled] = useTransformQuery<
        FetchIsAutomaticDecouplingEnabledQuery,
        FetchIsAutomaticDecouplingEnabledQueryVariables
    >()(
        FetchIsAutomaticDecouplingEnabled,
        {
            variables: {
                siteSetId,
            },
            skip: !hasValue(siteSetId),
            fetchPolicy: 'cache-and-network',
        },
        ({data}) => data?.finance.invoices.automaticInvoicing.isAutomaticDecouplingEnabled ?? null,
    );

    return {
        isAutomaticDecouplingEnabled,
    };
};
